import React from 'react';
import gql from 'graphql-tag';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    ListSubheader,
    CircularProgress
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { graphql } from 'react-apollo';
import CheckIcon from '@material-ui/icons/Check';
import LockIcon from '@material-ui/icons/Lock';
import CloseIcon from '@material-ui/icons/Close';

const FETCH_COURSES = gql`
    query{
        fetchCourses{
            name
            image
            levels{
                name
                units{
                    id
                    name
                    locked
                    current
                }
            }
        }
    }
`;

const statusIconStyle = { minWidth: 0 };

const UnitItem = ({ unit, isSelected, onClick }) => (
    <ListItem button selected={isSelected} disabled={unit.locked} onClick={() => onClick(unit)}>
        <ListItemText primary={unit.name} primaryTypographyProps={{ style: { fontWeight: isSelected ? 500 : 400 } }} />
        <ListItemIcon style={statusIconStyle}>
            {unit.locked ? <LockIcon fontSize="small" titleAccess="Bloqueado" /> : <CheckIcon fontSize="small" color="primary" titleAccess="Liberado" />}
        </ListItemIcon>
    </ListItem>
);

const CourseHeader = ({ course }) => (
    <div style={{ display: 'flex', alignItems: 'center', padding: '16px 16px 8px' }}>
        {course.image && <img src={course.image} alt="" style={{ height: 28, marginRight: 12 }} />}
        <Typography variant="subtitle1" style={{ fontWeight: 500 }}>{course.name}</Typography>
    </div>
);

const ChangeCourse = props => {

    let { loading, error, fetchCourses } = props.data;

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('xs'));

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            scroll="paper"
            fullWidth
            maxWidth="xs"
            fullScreen={isSmallScreen}
            aria-labelledby="change-course-title"
        >
            <DialogTitle id="change-course-title" disableTypography style={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="h6" style={{ flex: 1 }}>Selecionar livro</Typography>
                <IconButton edge="end" aria-label="Fechar" onClick={props.onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers style={{ padding: 0 }}>
                { loading && <div style={{ textAlign: 'center', padding: 24 }}><CircularProgress /></div> }
                { error && <Typography color="error" style={{ padding: 24 }}>Não foi possível carregar os livros.</Typography> }
                {
                    (fetchCourses || []).map(course => (
                        <React.Fragment key={course.name}>
                            <CourseHeader course={course} />
                            {
                                (course.levels || []).map(level => (
                                    <List
                                        key={level.name}
                                        subheader={<ListSubheader style={{ backgroundColor: theme.palette.background.paper }}>{level.name}</ListSubheader>}
                                    >
                                        {
                                            (level.units || []).map(unit => (
                                                <UnitItem
                                                    key={unit.id}
                                                    unit={unit}
                                                    isSelected={unit.id === props.selectedCourseUnitId}
                                                    onClick={props.onClickCourse}
                                                />
                                            ))
                                        }
                                    </List>
                                ))
                            }
                        </React.Fragment>
                    ))
                }
            </DialogContent>
        </Dialog>
    )
}

export default graphql(FETCH_COURSES)(ChangeCourse);
